import { isValidPhoneNumber } from 'libphonenumber-js/max'

import { hasNumericalSequence } from '@/lib/validation'

export function isValidOnboardingPhone(value: unknown): boolean {
  const phone = String(value ?? '').trim()
  return Boolean(phone) && !hasNumericalSequence(phone) && isValidPhoneNumber(phone)
}
